export const RAVEN_EVENTS_AI = [
    'EVENT_RAVEN_CAMERA_OBSCURED',
    'EVENT_RAVEN_CELLPHONE_DETECTED',
    'EVENT_RAVEN_DISTRACTED_DETECTED',
    'EVENT_RAVEN_DRINKING_DETECTED',
    'EVENT_RAVEN_EATING_DETECTED',
    'EVENT_RAVEN_POTENTIAL_RED_LIGHT_CAMERA_VIOLATION',
    'EVENT_RAVEN_POTENTIAL_SPEED_CAMERA_VIOLATION',
    'EVENT_RAVEN_SMOKING_DETECTED',
    'EVENT_RAVEN_STOP_SIGN_VIOLATION',
    'EVENT_RAVEN_TIRED_DETECTED',
    'EVENT_RAVEN_VISION_TAILGATING'
]

export const RAVEN_EVENTS_PROBLEM = [
    'EVENT_SPEEDING_STARTED',
    'EVENT_SPEEDING_STOPPED',
    'EVENT_IDLING_STARTED',
    'EVENT_IDLING_STOPPED',
    'EVENT_HARD_BRAKING',
    'EVENT_OBD_DTC_ALERT',
    'EVENT_OBD_DTC_CLEARED',
    'EVENT_SIM_CARD_ERROR',
    'EVENT_STORAGE_SD_CARD_TOO_SMALL',
    'EVENT_POSSIBLE_IMPACT',
    'EVENT_RAVEN_BAD_INSTALL_DETECTED',
    'EVENT_RAVEN_BAD_INSTALL_CLEARED',
    // local derived event types
    'EVENT_IDLING_MERGED',
    'EVENT_SPEEDING_MERGED'
]

export const RAVENS_EVENTS_GESTURE = [
    'EVENT_GESTURE_FULL_HAND',
    'EVENT_GESTURE_FIST',
    'EVENT_GESTURE_GENERIC_HAND'
]

export const RAVENS_EVENTS_PARKED = [
    'EVENT_ENGINE_OFF'
]

export const RAVENS_EVENTS_REMOTE = [
    'EVENT_REMOTE_REQUEST',
    'EVENT_WEBRTC_STREAMING_STARTED',
    'EVENT_WEBRTC_STREAMING_STOPPED'
]

export const RAVENS_EVENTS_SPEEDING = [
    'EVENT_SPEEDING_STARTED',
    'EVENT_SPEEDING_STOPPED',
    'EVENT_SPEEDING_MERGED' //runtime only event
]

export const RAVENS_EVENTS_GEOFENCE = [
    'EVENT_RAVEN_GEOFENCE_ENTER',
    'EVENT_RAVEN_GEOFENCE_EXIT'
]

export const RAVENS_EVENTS_ENGINE = [
    'EVENT_ENGINE_ON',
    'EVENT_ENGINE_OFF'
]
